import { render, staticRenderFns } from "./ProduitsEligiblesView.vue?vue&type=template&id=abcb91f8"
import script from "./ProduitsEligiblesView.vue?vue&type=script&lang=js"
export * from "./ProduitsEligiblesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports